import React, { useEffect, useState } from "react";
import {
  Box, Typography, Grid, Tabs, Tab,Checkbox, FormControlLabel, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Divider, TextField
} from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from "react-redux";
import ProductInfo from "./ProductInfo";
import { updateProductObj } from 'store/slice/PharmaSlice';
import { updateRMstatusAPI } from 'api/OmsOrdermgmtWebServices';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import { setTaskApiResponse, setTaskApiResponseError } from "store/slice/AppSlice";
import CommentMgmt from "./comment/CommentMgmt";

export default function TaskSpaceRMReceive() {
  const dispatch = useDispatch();
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { selectedTaskObj } = useSelector((state) => state.appslice.wkflow);
  const {taskApiResponse} = useSelector((state) => state.appslice.wkflow);

  // RM Ordered Date edit state
  const [editDate, setEditDate] = useState(false);
  const [rmOrderedDate, setRmOrderedDate] = useState(productObj?.rmorderedon ? productObj.rmorderedon.split('T')[0] : '');

  // RM Received Date edit state
  const [editReceivedOpen, setEditReceivedOpen] = useState(false);
  const [rmReceivedDate, setRmReceivedDate] = useState(productObj?.rmreceivedon ? productObj.rmreceivedon.split('T')[0] : '');
  const [rmIsAvailable, setRmIsAvailable] = useState(false);
  const [rmIsAvailableSaved, setRmIsAvailableSaved] = useState(false);
  const [taskCompleted, setTaskCompleted] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (taskApiResponse && taskApiResponse.success !== undefined) {
      setTaskCompleted(true);
    } else {
      dispatch(setCompleteTaskButtonEnabled(false));
      setTaskCompleted(false);

    }
      
  },[taskApiResponse]);

  useEffect(() => {
    
  },[rmIsAvailableSaved]);
  useEffect(() => {
    dispatch(setTaskApiResponse(null));
    dispatch(setTaskApiResponseError(''));
    
    setRmOrderedDate(productObj?.rmorderedon ? productObj.rmorderedon.split('T')[0] : '');
    setRmReceivedDate(productObj?.rmreceivedon ? productObj.rmreceivedon.split('T')[0] : '');
    console.log("productObj.rmstatus=>", productObj.rmstatus);

    if (productObj.rmstatus=== 'AVAILABLE' && productObj.rmreceivedon !== undefined) {
      dispatch(setCompleteTaskButtonEnabled(true));
    } else {
      dispatch(setCompleteTaskButtonEnabled(false));
    }
    
  }, [productObj]);


  const handleSaveReceived = () => {
    updateRMstatusAPI(
      {
        productId: productObj.id,
        rmReceivedOn: rmReceivedDate,
        rmStatus: rmIsAvailable?'AVAILABLE':''
      },
      (response) => {
        setEditReceivedOpen(false);
        setRmIsAvailableSaved(true);
        dispatch(updateProductObj(response.productInfo));
        dispatch(setCompleteTaskButtonEnabled(true));
      
      }
    );
  };
  
  return (
    <Grid container direction="row" sx={{ width: '100%' }}>
      <Grid item lg={12} md={12} sm={12} xs={12} >
        <Grid container sx={{ width: '100%' }}>
          <Grid item lg={4} md={4} sm={4} xs={12}>
            <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
                                            <Tabs
                                              value={tabIndex}
                                              onChange={(_, v) => setTabIndex(v)}
                                              variant="fullWidth"
                                              sx={{ borderBottom: 1, borderColor: 'divider' }}
                                            >
                                              <Tab label="Product Info" />
                                              <Tab label="Comments" />
                                            </Tabs>
                                            <Box sx={{}}>
                                              {tabIndex === 0 && (
                                                <ProductInfo maxHeight="70vh" />
                                              )}
                                              {tabIndex === 1 && (
                                                <Box sx={{ p: 2, minHeight: '70vh' }}>
                                                  <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                                                    <CommentMgmt maxHeight="60vh" status={1} />
                                                  </Box>
                                                </Box>
                                              )}
                                            </Box>
                                          </Box>
          </Grid>
          <Grid item lg={8} md={4} sm={4} xs={4} >
            <Grid container direction="column" sx={{ width: '100%' }}>
              {/* RM Ordered Date */}
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mt: 2 }}>
                <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 2, mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                    RM Ordered Date
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, justifyContent: 'space-between' }}>
                    
                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                          {productObj?.rmorderedon ? productObj.rmorderedon.split('T')[0] : 'N/A'}
                        </Typography>
                        {/* {selectedTaskObj.taskid === 5 && !taskCompleted && (
                          <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => setEditDate(true)}
                          >
                            <EditOutlinedIcon fontSize="small" />
                          </IconButton>
                        )} */}
                      
                  </Box>
                </Box>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mt: 2 }}>
                <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 2, mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                        RM Received Date
                      </Typography>
                      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        {productObj?.rmreceivedon ? productObj.rmreceivedon.split('T')[0] : 'N/A'}
                      </Typography>
                      <FormControlLabel
                        sx={{ mt: 2 }}
                        control={
                          <Checkbox
                            color="primary"
                            checked={productObj.rmstatus=== 'AVAILABLE'}
                            disabled ={true}
                          />
                        }
                        label="RM is available for the product mentioned on the left side"
                      />
                    </Box>
                    {!taskCompleted && (<IconButton
                      size="small"
                      sx={{ ml: 1 }}
                      onClick={() => setEditReceivedOpen(true)}
                    >
                      <EditOutlinedIcon fontSize="small" />
                    </IconButton>)}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* Edit RM Received Date Dialog */}
      <Dialog open={editReceivedOpen} onClose={() => setEditReceivedOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Edit RM Received Date & Availability
          </Typography>
          <IconButton aria-label="close" onClick={() => setEditReceivedOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField
              label="RM Received Date"
              type="date"
              size="small"
              value={rmReceivedDate}
              onChange={e => setRmReceivedDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              inputProps={{
                max: new Date().toISOString().split("T")[0] // Do not allow future date
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={rmIsAvailable}
                  onChange={e => setRmIsAvailable(e.target.checked)}
                  disabled={selectedTaskObj.taskid === 6 && selectedTaskObj.taskid === 6 && rmReceivedDate===''}
                />
              }
              label="RM is available for the product mentioned on the left side"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditReceivedOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSaveReceived}
            disabled={
              !(rmReceivedDate)
            }
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}